import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { API_BASE } from '../config'
import { C } from '../styles/tokens'

// Withdraw consent + delete my data (DPDP right / Google Play requirement).
export default function DeleteAccount() {
  const { user, fetchWithAuth, logout } = useAuth()
  const navigate = useNavigate()
  const [confirm, setConfirm] = React.useState(false)
  const [busy, setBusy] = React.useState(false)
  const [done, setDone] = React.useState(false)
  const [err, setErr] = React.useState('')

  const submit = async () => {
    setBusy(true); setErr('')
    try {
      const r = await fetchWithAuth(`${API_BASE}/api/account/delete`, { method: 'POST' })
      if (!r.ok) throw new Error()
      try { Object.keys(localStorage).filter(k => k.startsWith('revive_consent_')).forEach(k => localStorage.removeItem(k)) } catch {}
      setDone(true)
      setTimeout(() => { try { logout && logout() } catch {} ; navigate('/') }, 2600)
    } catch { setErr('Something went wrong. Please email us and we\'ll delete your data.') }
    setBusy(false)
  }

  const card = { maxWidth: 560, margin: '0 auto', background: '#fff', border: `1px solid ${C.border}`, borderRadius: 16, padding: '2rem 1.6rem' }

  return (
    <div style={{ minHeight: '100vh', background: '#F7FAF8', fontFamily: "'DM Sans',sans-serif", padding: '3rem 1.1rem' }}>
      {done ? (
        <div style={card}>
          <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>✅</div>
          <h1 style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.5rem', color: C.g900 }}>Consent withdrawn</h1>
          <p style={{ color: C.muted, lineHeight: 1.7, fontSize: '.9rem' }}>Your personal data has been deleted and your consent withdrawn. Any records we're legally required to keep (e.g. medical/order records) are retained only as long as the law requires, then removed. Signing you out…</p>
        </div>
      ) : (
        <div style={card}>
          <div style={{ fontSize: '2rem', marginBottom: 10 }}>🗑️</div>
          <h1 style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.5rem', color: C.g900, marginBottom: 8 }}>Withdraw consent &amp; delete my data</h1>

          {!user?.token ? (
            <>
              <p style={{ color: C.muted, lineHeight: 1.7, fontSize: '.9rem' }}>Please log in first so we can verify it's your account, then return here to delete your data.</p>
              <button onClick={() => navigate('/login?redirect=/delete-account')} style={{ marginTop: 14, background: C.g700, color: '#fff', border: 'none', borderRadius: 12, padding: '.85rem 1.6rem', fontWeight: 800, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>Log in</button>
            </>
          ) : (
            <>
              <p style={{ color: C.text, lineHeight: 1.7, fontSize: '.9rem' }}>
                This will <b>withdraw your consent</b> and <b>permanently delete your personal data</b> — your profile, saved addresses, progress photos, health logs, uploaded prescriptions and notifications.
              </p>
              <ul style={{ color: C.muted, fontSize: '.84rem', lineHeight: 1.7, paddingLeft: 18, marginTop: 4 }}>
                <li>You'll be signed out and will need to sign up again to use Revive.</li>
                <li>Some records (e.g. medical consultation and order records) may be <b>retained only as long as the law requires</b>, then deleted.</li>
                <li>This cannot be undone.</li>
              </ul>

              <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 16, fontSize: '.86rem', color: C.text, cursor: 'pointer' }}>
                <input type="checkbox" checked={confirm} onChange={e => setConfirm(e.target.checked)} style={{ marginTop: 3 }} />
                <span>I understand this deletes my data and closes my account.</span>
              </label>

              {err && <div style={{ color: '#C0392B', fontSize: '.82rem', marginTop: 12 }}>{err}</div>}

              <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
                <button onClick={() => navigate(-1)} style={{ flex: 1, background: '#fff', color: C.g900, border: `1.5px solid ${C.border}`, borderRadius: 12, padding: '.85rem', fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>Cancel</button>
                <button onClick={submit} disabled={!confirm || busy} style={{ flex: 1, background: (!confirm || busy) ? '#E4B4AE' : '#C0392B', color: '#fff', border: 'none', borderRadius: 12, padding: '.85rem', fontWeight: 800, cursor: (!confirm || busy) ? 'default' : 'pointer', fontFamily: "'DM Sans',sans-serif" }}>{busy ? 'Deleting…' : 'Delete my data'}</button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}
